import ReactGA from 'react-ga4';
import { devLog } from '.';
import Mixpanel from '../lib/mixpanel';
import store from '../store';

/**
 * Get userId from Redux store for tracking purposes
 * @returns {string|null} The user ID from Redux store, or null if not available
 */
export const getUserIdForTracking = () => {
  try {
    const state = store?.getState();
    return state?.user?.userInfo?.objectId || null;
  } catch (error) {
    console.error('Error getting userId from store:', error);
    return null;
  }
};

/**
 * @deprecated use trackDetailedEvent to track both mixpanel and GA
 */
export const trackEvent = (eventName) => {
  // Don't track in dev mode
  if (!import.meta.env.NODE_ENV || import.meta.env.NODE_ENV !== 'production') {
    if (import.meta.env.VITE_LOG_TRACKING_EVENTS === true) {
      devLog('tracking', '- NOT tracked', eventName);
    }
    return;
  }

  // Send tracking events
  if (import.meta.env.VITE_LOG_TRACKING_EVENTS === true) {
    devLog('tracking', 'tracked', eventName);
  }
  ReactGA.event(eventName);
};

/**
 * Track with mixpanel and GA
 * Automatically includes userId from Redux store if not provided in properties
 * @param eventName
 * @param properties - if user_id is not provided, it will be automatically added from Redux store
 */
export const trackDetailedEvent = (eventName, properties = {}) => {
  // Automatically add userId from Redux store if not provided
  const trackingProperties = { ...properties };
  if (!trackingProperties.user_id) {
    const userId = getUserIdForTracking();
    if (userId) {
      trackingProperties.user_id = userId;
    }
  }

  Mixpanel.track(eventName, trackingProperties);
  trackEvent(eventName);
};
